// extracted by mini-css-extract-plugin
export default {"editButton":"EditableForm_editButton__BdiKH","preloader":"EditableForm_preloader__kmA5J"};